<template>
    <div class="vue-sidebar-collapse">
        <div v-bind:class="styles" v-on:click="open = !open">
            <span class="inline-block w-8 text-xl text-gray-300 mr-3 flex-shrink-0">
                <span v-bind:class="icon"></span>
            </span>
            <span class="flex-1" v-text="label"></span>
        </div>
        <div v-show="open" class="pl-4 py-2">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['label', 'active', 'icon'],
        data: function() {
            return {
                open: false,
            };
        },
        mounted: function() {
            this.open = this.active;
        },
        computed: {
            styles() {
                return (this.active)
                    ? 'group flex items-center px-2 py-2 text-sm font-medium rounded-md bg-gray-900 text-white cursor-pointer'
                    : 'group flex items-center px-2 py-2 text-sm font-medium rounded-md text-gray-300 cursor-pointer hover:bg-gray-700 hover:text-white';
            },
        },
        methods: {
            //
        }
    }
</script>
